import React from 'react';
import gql from 'graphql-tag';
import FormFieldFaviconUpload from '../components/FormFieldFaviconUpload';
import useMutation from '../../modules/react/hooks/useMutation';

export const UPLOAD_IMAGE = gql`
  mutation FormFieldFaviconImageUpload($file: Upload!) {
    imageUpload(file: $file) {
      file {
        path
      }
      userErrors {
        code
        message
      }
    }
  }
`;

const propTypes = {};

const defaultProps = {};

const FormFieldFavicon = ({
  ...rest
}) => {
  let filePath;
  let uploadErrors;

  const [uploadImage, { data, loading, error }] = useMutation(UPLOAD_IMAGE);

  const onUpload = ({ target: { files: [file] } }) => (
    uploadImage({ variables: { file } })
  );

  if (data) {
    const { file, userErrors } = data.imageUpload;

    if (file) {
      filePath = file.path;
    }

    if (userErrors) {
      uploadErrors = userErrors;
    }
  }

  if (error) {
    const message = { code: 0, message: 'Could not upload favicon.' };
    uploadErrors = uploadErrors ? [...uploadErrors, message] : [message];
  }

  return (
    <FormFieldFaviconUpload
      {...rest}
      accept="image/*"
      filePath={filePath}
      loading={loading}
      onUpload={onUpload}
      uploadErrors={uploadErrors}
    />
  );
};

FormFieldFavicon.propTypes = propTypes;
FormFieldFavicon.defaultProps = defaultProps;

export default FormFieldFavicon;
